import { isValidProfileEmail, normalizeProfileEmail } from '../services/profileEmailService';

export function isProfileComplete(userProfile) {
  return Boolean(
    userProfile?.firstName?.trim()
    && userProfile?.lastName?.trim()
    && isValidProfileEmail(userProfile?.email)
    && userProfile?.phone?.trim()
    && userProfile?.jobPosition?.trim()
    && userProfile?.workArea?.trim(),
  );
}

export function profileCompletionErrorMessage(userProfile) {
  if (!userProfile?.firstName?.trim() || !userProfile?.lastName?.trim()) {
    return 'Prosimo, izpolnite ime in priimek.';
  }
  if (!normalizeProfileEmail(userProfile?.email)) {
    return 'Prosimo, vnesite elektronski naslov.';
  }
  if (!isValidProfileEmail(userProfile?.email)) {
    return 'Prosimo, vnesite veljaven elektronski naslov.';
  }
  if (!userProfile?.phone?.trim()) {
    return 'Prosimo, izpolnite telefonsko številko.';
  }
  if (!userProfile?.jobPosition?.trim()) {
    return 'Prosimo, izpolnite delovno mesto.';
  }
  if (!userProfile?.workArea?.trim()) {
    return 'Prosimo, izpolnite oddelek / področje dela.';
  }
  return 'Prosimo, izpolnite vse obvezne podatke profila.';
}
